<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-store-alt"></i> Giro de Carteira</h3>
      </div>
    </div>
    <GiroCarteiraAdd v-if="showAdd" ref="giroCarteiraAdd" v-on:Back="onBack" />
    <GiroCarteiraList v-else ref="giroCarteiraList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import GiroCarteiraAdd from './components/add/GiroCarteiraAdd.vue'
import GiroCarteiraList from './components/list/GiroCarteiraList.vue'

export default {
  name: 'GiroCarteira',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    GiroCarteiraAdd,
    GiroCarteiraList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.giroCarteiraAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.giroCarteiraList.onLoad()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/movimentacoes/giroCarteira/GiroCarteira.vue